import { TextKey } from '@mews-commander/enums';
import { Body, Link, Stack } from '@optimus-web/core';
import { LocalizedPageTitle, LocalizedParagraph, LocalizedSmallParagraph } from '@mews-commander/ui';
import { LocalizedText, MEWS_CONTACT_US_URL } from '@mews/framework';
import { TwoFactorAuthenticationForm } from './TwoFactorAuthenticationForm';

export const TwoFactorAuthenticationApp = () => (
    <Stack spacing="500" vertical>
        <Stack spacing="100" vertical>
            <LocalizedPageTitle textKey={TextKey.VerifyIdentity} />
            <LocalizedParagraph textKey={TextKey.VerifyIdentityInstructions} variant="secondary" />
        </Stack>
        <Stack spacing="300" vertical>
            <TwoFactorAuthenticationForm />

            <Stack spacing="50" vertical>
                <LocalizedSmallParagraph textKey={TextKey.NoTwoFactorCodeTitle} />
                <Body size="small" variant="secondary">
                    <LocalizedText
                        substitutes={{
                            contactUsHere: (
                                <Link href={MEWS_CONTACT_US_URL}>
                                    <LocalizedText textKey={TextKey.ContactUsHere} />
                                </Link>
                            ),
                        }}
                        textKey={TextKey.NoTwoFactorCodeInstructions}
                    />
                </Body>
            </Stack>
        </Stack>
    </Stack>
);
